import { constants, isDisplayable } from "@qgiv/core-js";

const {
    ENUMS: { GivingPlanSystemType },
} = constants;

export const getMatchingGiftNoticeFlag = (settings) => {
    const {
        pledgeActive,
        activePlans,
        givingPlanSystemType,
        hasSelectedRecurringDonation,
        isSinglePageForm,
        matchingGiftSystemField,
        currentDisplay,
        hasActiveFulfillment,
        enableMatching,
        displayMatchingGiftNotice,
    } = settings;
    const hasActivePlans = pledgeActive && activePlans.length > 0;

    const isOnFlexibleGivingPlans =
        hasActivePlans &&
        givingPlanSystemType === GivingPlanSystemType.FLEXIBLE;

    const isOnPredefinedGivingPlans =
        hasActivePlans &&
        givingPlanSystemType === GivingPlanSystemType.PREDEFINED;

    const isFlexibleGivingPlansOneTimeTab =
        isOnFlexibleGivingPlans && !hasSelectedRecurringDonation;

    const isFlexibleOneTimeOrPlansDisabled =
        !hasActivePlans || isFlexibleGivingPlansOneTimeTab;

    const hasValidDisplaySettings =
        matchingGiftSystemField?.options &&
        isDisplayable(matchingGiftSystemField.options, currentDisplay);

    // Matching Gift display notice should be rendered here for all giving system types
    // except for flexible giving plans (recurring tab)
    const shouldDisplayMatchingGiftNotice =
        !hasActiveFulfillment &&
        !isSinglePageForm &&
        (isFlexibleOneTimeOrPlansDisabled || isOnPredefinedGivingPlans) &&
        enableMatching &&
        displayMatchingGiftNotice &&
        hasValidDisplaySettings;

    return shouldDisplayMatchingGiftNotice;
};
